import { render, staticRenderFns } from "./truck-detail.vue?vue&type=template&id=d28bcb38&"
import script from "./truck-detail.vue?vue&type=script&lang=js&"
export * from "./truck-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports